import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import UpdateModal from '../component/UpdateModal';
import * as actions from '../../../action';
import * as c from '../../../constant';
import TaxRevenueInformation from '../component/TaxRevenueInformation';

function ViewBusinessLinesModal({
  updateList,
  businessLinesId,
  businessLinesInfo,
  removeNewBusinessLines,
  getNewBusinessLinesList,
  ordinanceRevisionId,
  newBusinessNaturesId,
  getSingleNewBusinessLines,
  newBusinessLinesInfo,
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    garbage_code: '',
    license_code: '',
    permit_code: '',
    sanitary_code: '',
  });
  const setModal = useContext(ModalContext);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    if (_.isEmpty(businessLinesId)) return;
    getSingleNewBusinessLines(newBusinessNaturesId, businessLinesId);
  }, [businessLinesId]);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.BUSINESS_LINES_FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  const handleUpdateBusinessLines = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={updateList}
          businessLinesId={businessLinesId}
          businessLinesInfo={businessLinesInfo}
          ordinanceRevisionId={ordinanceRevisionId}
          newBusinessNaturesId={newBusinessNaturesId}
        />
      ),
      title: 'Update Business Line',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveBusinessLines = e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business line?',
      () => {
        removeNewBusinessLines(
          newBusinessNaturesId,
          businessLinesInfo.id,
          () => {
            setModal({ isOpen: false });
            getNewBusinessLinesList(newBusinessNaturesId, {
              ordinance_revision_id: ordinanceRevisionId,
            });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const srcDownload = `${
    process.env.REACT_APP_WS
  }api/v1/bpls/administrator/report/business_lines/${businessLinesId}/generate?bearer_token=${token}
  &email=${_.get(authProfile, 'email')}&output=D`;

  return (
    <Modal.Body>
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark" width="150">
              Code
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b className="text-success">{_.get(formData, 'code')}</b>
            </td>
            <td style={{ textAlign: 'end' }}>
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1   "
                href={srcDownload}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-print" /> Generate PDF
              </a>

              <button
                onClick={handleUpdateBusinessLines}
                type="button"
                className="btn-blank"
              >
                <i className="far fa-edit icon-edit" />
              </button>
              <button
                type="button"
                className="btn-blank"
                onClick={handleRemoveBusinessLines}
              >
                <i className="far fa-trash-alt icon-delete" />
              </button>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b className="text-success">{_.get(formData, 'name')}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <TaxRevenueInformation data={newBusinessLinesInfo} />
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </Modal.Body>
  );
}

ViewBusinessLinesModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  removeNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  businessLinesId: PropTypes.string.isRequired,
  businessLinesInfo: PropTypes.instanceOf(Object).isRequired,
  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  newBusinessNaturesId: PropTypes.string.isRequired,
  getSingleNewBusinessLines: PropTypes.instanceOf(Function).isRequired,
  newBusinessLinesInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessLinesInfo:
    _.get(api, `${c.GET_SINGLE_NEW_BUSINESS_LINES}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewBusinessLinesModal);
